import React, { FunctionComponent, SVGAttributes } from 'react';

const CheckIcon: FunctionComponent<SVGAttributes<any>> = (props) => (
    <svg
        width="2.4rem"
        height="2.4rem"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 36 36"
        fill="currentColor"
        {...props}
    >
        <path d="m33.134 9.537-18 17.625-1.273 1.246-1.259-1.26-9.75-9.75 2.546-2.545 8.49 8.49L30.615 6.966l2.52 2.572Z" />
    </svg>
);

export default CheckIcon;
